export const LINKS: { [key: string]: string } = {
    ANNUITY_PRIVACY_POLICY: "/privacy-policy",
    ANNUITY_PRIVACY_NOTICE_DOCUMENT_LINK: "/privacy-policy",
    ANNUITY_TERMS_AND_CONDITIONS: "/terms",
    ANNUITY_TERMS_AND_CONDITIONS_DOCUMENT_LINK: "https://documents.theidol.com/api/terms?company=annuityready",
    ANNUITY_COOKIE_POLICY: "https://documents.theidol.com/api/cookiepolicy",
    /* eslint-disable max-len, vue/max-len */
    ANNUITY_MODERN_SLAVERY_STATEMENT: "https://group.legalandgeneral.com/media/fgdchnjt/modern-slavery-statement-2025.pdf",
    ACCESSIBILITY_LINK: "/accessibility",
    OUR_SERVICES_LINK: "/our-services",
    UNSUBSCRIBE_LINK: "https://customers.theidol.com/unsubscribe",
    /* eslint-disable max-len, vue/max-len */
    PENSION_WISE_LINK: "https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise/book-a-free-pension-wise-appointment?source=pw",
    MONEY_HELPER_LINK: "https://www.moneyhelper.org.uk/en/pensions-and-retirement",
    DEMANDS_AND_NEEDS: "/demands-and-needs",
};
